import React, { FC, useContext } from "react";
import styles from "./FormContato.module.scss";
import LogoVetSaude from "./../../../Static/Images/vet_saude.png";
import { Form } from "../../Form";
import FormContatoSchema from "./FormContato.schema";
import { Grid } from "@material-ui/core";
import TextInput from "../../Form/Inputs/TextInput";
import { isMobile } from "react-device-detect";
import MaskInput from "../../Form/Inputs/MaskInput";
import { SiteButton } from "../../UI/Button/Button.style";
import { ILeadContext } from "../../../Context/Lead/Interfaces/ILeadContext";
import { useHistory, useRouteMatch } from "react-router-dom";
import { IPlanoContext } from "../../../Context/Plano/Interfaces/IPlanoContext";

interface IFormContato {
  leadContext: ILeadContext;
  planoContext: IPlanoContext;
}

const FormContato: FC<IFormContato> = ({ leadContext }) => {
  const history = useHistory();
  const plano_selecionado =
    useRouteMatch<{ identifier: string }>("/:identifier");

  return (
    <div
      id="formContato"
      className={`${styles["FormContato"]} ${styles["mobile"]}`}
    >
      <div className={styles["Title"]}>
        <span>Adquira agora um plano</span>
        <img alt="Logo Vet Saude" src={LogoVetSaude} />
        <Form
          schema={FormContatoSchema}
          initialValues={{
            planoEscolhido: plano_selecionado?.params?.identifier,
          }}
          onSubmit={(values, helpers) => {
            leadContext.effects &&
              leadContext.effects.saveLead(values, helpers, () => {
                history.push("/concluir_contato");
                setTimeout(() => {
                  history.push("/home");
                }, 60000);
              });
          }}
        >
          {({ handleSubmit }) => {
            return (
              <>
                <Grid container spacing={3}>
                  <Grid item xs className={styles["item"]}>
                    <TextInput
                      name="nome"
                      id="inputNome"
                      isSiteInput
                      fullWidth={isMobile}
                      placeholder="Nome"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs className={styles["item"]}>
                    <TextInput
                      name="email"
                      isSiteInput
                      fullWidth={isMobile}
                      placeholder="Email para contato"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs className={styles["item"]}>
                    <MaskInput
                      name="telefone"
                      isSiteInput
                      fullWidth={isMobile}
                      placeholder="Telefone para Contato"
                      format={{
                        format: "(##) # ####-####",
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs className={styles["item"]}>
                    <TextInput
                      name="estado"
                      isSiteInput
                      fullWidth={isMobile}
                      placeholder="Estado"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs className={styles["item"]}>
                    <TextInput
                      name="cidade"
                      isSiteInput
                      fullWidth={isMobile}
                      placeholder="Cidade"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs>
                    <SiteButton
                      className={styles["atendimento"]}
                      onClick={() => {
                        handleSubmit();
                      }}
                      color={"--bg-gradient-primary"}
                    >
                      <div className={styles["border"]}>
                        Solicitar Atendimento
                      </div>
                    </SiteButton>
                  </Grid>
                </Grid>
              </>
            );
          }}
        </Form>
      </div>
    </div>
  );
};

export default FormContato;
